define('SC.SummitThemeExtension.Checkout', [
  'SC.SummitThemeExtension.ErrorManagement',
  'SC.SummitThemeExtension.Footer',
  'SC.SummitThemeExtension.Footer.Simplified',
  'SC.SummitThemeExtension.ApplicationSkeleton.Layout',
  'SC.SummitThemeExtension.ItemRelations.SC.Configuration',
  'SC.SummitThemeExtension.LoginRegister.Login.View',
  'SC.SummitThemeExtension.Address.Details',
  'SC.SummitThemeExtension.LoadWebFont',
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.LayoutHelper'
], function SCSummitThemeExtensionCheckoutEntryPoint(
  SummitThemeExtErrorManagement,
  SummitThemeExtFooter,
  SummitThemeExtFooterSimplified,
  SummitThemeExtApplicationSkeleton,
  SummitThemeExtItemRelations,
  SummitThemeExtLoginRegister,
  SummitThemeExtAddressDetails,
  SummitThemeExtLoadWebFont,
  Configuration,
  LayoutHelper
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      Configuration.setEnvironment(container.getComponent('Environment'));
      LayoutHelper.setLayoutComponent(container.getComponent('Layout'));
      SummitThemeExtApplicationSkeleton.toggleViewportToMobileSupport();
      SummitThemeExtErrorManagement.loadModule();
      SummitThemeExtFooter.loadModule();
      SummitThemeExtFooterSimplified.loadModule();
      SummitThemeExtApplicationSkeleton.loadModule();
      SummitThemeExtItemRelations.loadModule();
      SummitThemeExtLoginRegister.loadModule();
      SummitThemeExtAddressDetails.loadModule();
      SummitThemeExtLoadWebFont.loadModule();
    }
  };
});
